import InstructionBox from '../components/instructionBox';
import { connect } from 'react-redux';


const mapStateToProps = (state, ownProps) => ({
    visible: state.ui.index === 0 && state.clientConfiguration.showInstructionBox    
})
const InstructionBoxContainer = connect(mapStateToProps)(InstructionBox)

export default InstructionBoxContainer

